import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X, Bus } from "lucide-react";

const links = [
  { href: "#acasa", label: "Acasă" },
  { href: "#despre", label: "Despre noi" },
  { href: "#excursii", label: "Excursii" },
  { href: "#preturi", label: "Rute & Prețuri" },
  { href: "#recenzii", label: "Recenzii" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-slate-900/80 backdrop-blur-xl border-b border-slate-800/70 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <a
            href="#acasa"
            data-testid="navbar-logo"
            className="flex items-center gap-2 group"
          >
            <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-amber-500 text-slate-950 group-hover:bg-amber-400 transition-colors">
              <Bus className="w-5 h-5" strokeWidth={2.4} />
            </span>
            <span
              className={`font-bold text-lg tracking-tight ${
                scrolled ? "text-white" : "text-white"
              }`}
            >
              Global<span className="text-amber-500">Transport</span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.href.slice(1)}`}
                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                  scrolled
                    ? "text-slate-200 hover:text-white hover:bg-slate-100"
                    : "text-slate-100 hover:text-white hover:bg-slate-900/10"
                }`}
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Button
              data-testid="navbar-cta-rezerva"
              asChild
              className="hidden sm:inline-flex bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold rounded-full px-5"
            >
              <a href="#rezervare">Rezervă cursă</a>
            </Button>
            <button
              data-testid="navbar-mobile-toggle"
              onClick={() => setOpen((o) => !o)}
              className={`lg:hidden p-2 rounded-md ${
                scrolled ? "text-white" : "text-white"
              }`}
              aria-label="Meniu"
            >
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {open && (
          <div
            data-testid="navbar-mobile-menu"
            className="lg:hidden pb-4 pt-2 border-t border-slate-800/40 bg-slate-900/95 backdrop-blur-xl rounded-b-xl"
          >
            <div className="flex flex-col gap-1 pt-2">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-link-${l.href.slice(1)}`}
                  className="px-4 py-3 text-slate-200 hover:bg-slate-100 rounded-md font-medium"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#rezervare"
                onClick={() => setOpen(false)}
                data-testid="mobile-cta-rezerva"
                className="mx-2 mt-2 text-center bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold rounded-full py-3"
              >
                Rezervă cursă
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
